<template>
    <div
    class="container"
    style="background-color: #181a1b; color: white; padding: 20px; margin-top: 10px; border-radius: 10px;"
    >
        <div class="d-flex flex-column">
            <h2 class="center">Custom Assessment</h2>
            <div class="p-4 row">            
                <div class="col-md-6 mb-3">
                    <label for="timeLimit">Amount of Question</label>
                    <select v-model="amountOfQuestionsSelected" class="form-control" id="amountOfQuestions" style="background-color: #252729; color: white">
                        <option value="5" selected>5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="20">20</option>
                        <option value="25">25</option>
                        <option value="30">30</option>
                    </select>
                </div>
                <div class="col-md-6 mb-3">
                    <label for="timeLimit">Time Limit</label>
                    <select v-model="timelimitSelected" class="form-control" id="timeLimit" style="background-color: #252729; color: white">
                    <option value="0" selected>No limit</option>
                    <option value="5">5 minutes</option>
                    <option value="10">10 minutes</option>
                    <option value="20">20 minutes</option>
                    <option value="30">30 minutes</option>
                    <option value="40">40 minutes</option>
                    <option value="50">50 minutes</option>
                    <option value="60">60 minutes</option>
                    <option value="70">70 minutes</option>
                    </select>
                </div>
            </div>
            <div class="p-4">
                <h4>Assesssment Content</h4>
            </div>
            <div class="p-4 row">
                <div class="col">
                    <div class="row">
                        <div class="col-md-9">
                            <select
                            id="testName"
                            class="form-control"
                            @change="showDescription"
                            v-model="selectedTest"
                            style="background-color: #252729; color: white"
                            >
                                <option value="" selected>Select Assessment</option>
                                <optgroup v-for="(tests, groupName) in groupedTests" :label="groupName" :key="groupName">
                                    <option v-for="test in tests" :key="test.id" :value="test.id">
                                    {{ test.name }}
                                    </option>
                                </optgroup>
                            </select>
                        </div>
                        <div class="col-md-1">
                            <button class="btn btn-primary" @click="handleAddAssessmentButton">Add</button>
                        </div>
                    </div>
                </div>
                <div class="row pt-3">
                    <div class="col">                    
                        <div class="list-group assessment-list" id="list-tab" role="tablist">
                            <a class="list-group-item list-group-item-action active" id="list-home-list" data-toggle="list" href="#list-home" role="tab">Included in Assessment</a>
                            <a v-for="(assessment, index) in multiAssessmentsSelected" class="list-group-item list-group-item-action" id="list-home-list" data-toggle="list" href="#list-home" role="tab" :key="index" @click="removeAssessment(index)">{{ assessment.name }}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-4 row justify-content-center">
                <div class="col-md-6">
                    <label for="email">Candidate's Email</label>
                        <input
                        type="email"
                        id="email"
                        class="form-control"
                        v-model="email"
                        required
                        style="background-color: #252729; color: white"
                        />
                </div>
            </div>
            <div class="p-4 row justify-content-center">
                <button class="btn btn-primary submit-button" @click="sendInvite">Dispatch Assessment</button>
            </div>
        </div>
    </div>
    <DialogModal 
    :error-message="assessmentSentMessage" 
    :error-title="assessmentSentTitle" 
    :info-class="assessmentSentInfoClass" 
    :modal-emit="true" 
    @close-action="handleModalCloseAfterSend"
    ref="dialogModal" />
</template>
<script>
import { getCookie } from '@/utils/cookies/cookieUtils';
import { endpoint } from '@/utils/endpoint/endpointUtils.js';
import router from '../router';
import DialogModal from './DialogModal.vue';
import { joinPropertyWithCommas } from '@/utils/arrays';

export default {
    components: {
        DialogModal
    },
    data() {
        return {
            tests: [],
            selectedTest: '',
            amountOfQuestionsSelected: 5,
            timelimitSelected: 0,
            multiAssessmentsSelected: [],
            email: '',
            assessmentSentMessage: 'An e-mail has been sent to the candidate containing a code to take this assessment.',
            assessmentSentTitle: 'Assessment Sent to Candidate',
            assessmentSentInfoClass: 'alert alert-warning',
            assessmentList: '',
            successfulSendInvite: false
        }
    },
    created() {
        this.fetchAssessmentList();
    },
    computed: {
        groupedTests() {
            const groups = {
            'Practical Assessments': [],
            'Knowledge Assessments': [],
            'Other Assessments': []
            };

            // Iterate through each test and assign it to the appropriate group
            this.tests.forEach(test => {
            if (test.name.includes('Practical')) {
                groups['Practical Assessments'].push(test);
            } else if (test.name.includes('Knowledge')) {
                groups['Knowledge Assessments'].push(test);
            } else {
                groups['Other Assessments'].push(test);
            }
            });

            return groups;
        }
    },
    methods: {
        async fetchAssessmentList() {
            const token = getCookie('token');
            try {
                const response = await fetch(endpoint + '/api/Assessments/GetAssessmentList', {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Bearer ' + token,
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();

                const assessments = Object.entries(data.assessments).map(([id, details]) => ({ id, name: details.title }));
                const assessmentDescriptions = Object.entries(data.assessments).map(([id, details]) => ({ id: id, description: details.description }));

                this.tests = assessments;
                console.log(this.tests);
                this.descriptions = assessmentDescriptions;
            } catch (error) {
                console.error(error);
            }
        },
        handleAddAssessmentButton() {
            const selectedTestId = this.selectedTest;
            if (selectedTestId) {
                const selectedTest = this.tests.find(test => test.id === selectedTestId);
                if (selectedTest) {
                    this.multiAssessmentsSelected.push(selectedTest);
                }
            }
        },
        removeAssessment(index) {
            this.multiAssessmentsSelected.splice(index, 1);
        },
        async sendInvite() {
            if (!this.selectedTest || !this.email || !(this.multiAssessmentsSelected.length > 0)) {
                alert('Please select a test and provide a valid email address');
                return;
            }

            // Join assessments selected to csv.
            this.assessmentList = joinPropertyWithCommas(this.multiAssessmentsSelected, 'id');

            const body = {
                    dispatchUserId: getCookie('userid'),
                    examTitle: this.assessmentList,
                    email: this.email,
                    // Mixed assessment > 0.
                    // It holds the number of questions too!
                    mixedAssessment: this.amountOfQuestionsSelected,
                    timeLimit: this.timelimitSelected
                };

            const token = getCookie('token');

            try {
                const response = await fetch(endpoint + '/api/Assessments/DispatchAssessment', {
                    method: 'POST',
                    headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(body),
                });

                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                console.log(data);

                // Code to send invite goes here
                this.assessmentSentMessage = 'An e-mail has been sent to the candidate containing a dispatch code to take this assessment.';
                this.dispatchCode = data.dispatchCode;
                this.assessmentSentToEmail = this.email;
                this.assessmentNameSentToEmail = this.selectedTest;
                this.successfulSendInvite = true;
                
                this.$refs.dialogModal.openModal();
                // Reset form fields
                this.selectedTest = '';
                this.email = '';
            } catch (error) {
                console.log(error);
            }
        },
        handleModalCloseAfterSend(successSend) {
            console.log('closeModal emit recieved.');
            if (this.successfulSendInvite) {
                router.push('/dispatched');
            }
        }
    }
}
</script>
<style scoped>
.container {
  width: 90%; /* Adjust width for smaller screens */
  max-width: 800px; /* Limit maximum width */
  margin: 0 auto; /* Center the container horizontally */
}

.description-container {
  max-width: 400px; /* Adjust width as needed */
  overflow: auto; /* Add scrollbar if content exceeds container */
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.assessment-list {
    border: 1px;
    border-style: solid;
    border-color: azure;
    min-height: 80px;
}

.list-group-item.active {
    background-color:darkslateblue
}

.btn {
    background-color: #382d61;
    color: #fff;
    border: none;
    border-radius: 3px;
    cursor: pointer;
}

.btn:hover {
    background-color: #72018f;
}

.btn.submit-button {
    padding: 10px;
    background-color: #382d61;
    color: #fff;
    border: none;
    border-radius: 3px;
    cursor: pointer;
  }
  
  .btn.submit-button:hover {
    background-color: #72018f;
  }

  @media screen and (max-width: 576px) {
  .container {
    padding: 10px;
  }
}
</style>